import styled from 'styled-components';

export const Bar = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1080; /* acima dos modais bootstrap padrão (1050) */
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  flex-wrap: wrap;
  padding: 10px 20px;
  background-color: ${(props) => props.theme.color.bg.tertiary};
  color: ${(props) => props.theme.color.text.inverse};
  font-family: ${(props) => props.theme.font.body.family};
  font-size: ${(props) => props.theme.font.body.size.small};
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.2);

  strong {
    font-weight: ${(props) => props.theme.font.body.weight.bold};
  }

  @media print {
    display: none;
  }
`;

export const BackButton = styled.button`
  border: none;
  border-radius: 3px;
  padding: 6px 16px;
  background-color: ${(props) => props.theme.color.ui.orange};
  color: ${(props) => props.theme.color.text.inverse};
  font-family: ${(props) => props.theme.font.body.family};
  font-size: ${(props) => props.theme.font.body.size.small};
  font-weight: ${(props) => props.theme.font.body.weight.bold};
  cursor: pointer;

  &:disabled {
    opacity: 0.6;
    cursor: default;
  }
`;
